/* eslint-disable import/prefer-default-export */
export function addSeparators(value) {
  var dateTimeMillis = value.substring(0, 23);
  var micros = value.substring(23, 26);
  var nanos = value.substring(26);
  return [dateTimeMillis, micros, nanos].filter(v => v !== '').join('\u200B');
}
//# sourceMappingURL=DateTimeInputUtils.js.map